import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { Box, Text, xcss } from '@atlaskit/primitives';
import { messages } from './messages';
const captionWrapperStyle = css({
  marginTop: "var(--ds-space-100, 8px)",
  textAlign: 'center',
  position: 'relative',
  color: "var(--ds-text-subtle, #44546F)"
});
const placeholderStyle = xcss({
  color: 'color.text.subtlest',
  position: 'absolute',
  top: 'space.0',
  width: '100%'
});
export class CaptionComponent extends React.Component {
  render() {
    const {
      selected,
      hasContent,
      children,
      dataAttributes,
      intl: {
        formatMessage
      }
    } = this.props;
    const showPlaceholder = !selected && !hasContent;
    return jsx("div", _extends({
      "data-media-caption": true,
      "data-testid": "media-caption"
    }, dataAttributes, {
      css: captionWrapperStyle
    }), showPlaceholder ? jsx(Box, {
      xcss: placeholderStyle
    }, jsx(Text, null, formatMessage(messages.placeholder))) : null, children);
  }
}
export default injectIntl(CaptionComponent);